var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":true}},[_c('v-layout',[_c('v-flex',[(_vm.warn)?_c('p',{staticClass:"mb-0 f-1"},[_vm._v(" "+_vm._s(_vm.warnText || _vm.$t('description.warn'))+" ")]):_vm._e(),_c('p',{staticClass:"mb-0 f-1"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }